<template>
  <AuthShell>
    <h1 class="auth-title">Sign in</h1>
    <p class="auth-sub">
      Use your Valsplat or Braingineers Google account to continue.
    </p>

    <button class="auth-google" type="button" @click="google">
      <svg class="auth-google__g" viewBox="0 0 18 18" aria-hidden="true">
        <path
          fill="#4285F4"
          d="M17.64 9.2c0-.64-.06-1.25-.16-1.84H9v3.48h4.84a4.14 4.14 0 0 1-1.8 2.72v2.26h2.92c1.7-1.57 2.68-3.88 2.68-6.62z"
        />
        <path
          fill="#34A853"
          d="M9 18c2.43 0 4.47-.8 5.96-2.18l-2.92-2.26c-.8.54-1.84.86-3.04.86-2.34 0-4.32-1.58-5.03-3.7H.96v2.33A9 9 0 0 0 9 18z"
        />
        <path
          fill="#FBBC05"
          d="M3.97 10.72a5.4 5.4 0 0 1 0-3.44V4.95H.96a9 9 0 0 0 0 8.1l3.01-2.33z"
        />
        <path
          fill="#EA4335"
          d="M9 3.58c1.32 0 2.5.45 3.44 1.35l2.58-2.58C13.46.9 11.42 0 9 0A9 9 0 0 0 .96 4.95l3.01 2.33C4.68 5.16 6.66 3.58 9 3.58z"
        />
      </svg>
      <span>Sign in with Google</span>
    </button>

    <template #footer>
      <div class="auth-foot-stack">
        <span>Powered by Braingineers</span>
        <span class="auth-foot-alt">
          Invited as a guest?
          <router-link class="auth-link" to="/guest"
            >Use your invite email</router-link
          >
        </span>
      </div>
    </template>
  </AuthShell>
</template>

<script>
import { getAuth, signInWithPopup, GoogleAuthProvider } from "firebase/auth";
import AuthShell from "@/components/AuthShell.vue";

export default {
  components: { AuthShell },
  methods: {
    async google() {
      const provider = new GoogleAuthProvider();
      const auth = getAuth();
      signInWithPopup(auth, provider)
        .then((result) => {
          this.$store.commit("setUser", result.user);
        })
        .catch((error) => {
          console.log(error);
          console.log(error.message);
        });
    },
  },
};
</script>

<style scoped>
.auth-title {
  font-family: var(--font-display);
  font-weight: 700;
  font-size: 34px;
  letter-spacing: -0.02em;
  line-height: 1.1;
  color: var(--vp-black);
  margin: 0 0 10px;
}
.auth-sub {
  font-family: var(--font-body);
  font-size: 15px;
  color: var(--fg-3);
  line-height: 1.5;
  margin: 0 0 28px;
}
.auth-google {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  width: 100%;
  height: 48px;
  background: var(--vp-white);
  border: 1px solid var(--vp-black);
  border-radius: 0;
  cursor: pointer;
  font-family: var(--font-ui);
  font-size: 14px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: var(--vp-black);
  transition: background var(--dur-fast) var(--ease-hover),
    color var(--dur-fast) var(--ease-hover),
    transform var(--dur-press) var(--ease-out);
}
.auth-google:hover {
  background: var(--vp-black);
  color: var(--vp-white);
}
.auth-google:active {
  transform: scale(0.99);
}
.auth-google__g {
  width: 18px;
  height: 18px;
  flex-shrink: 0;
  background: var(--vp-white);
  padding: 1px;
  box-sizing: content-box;
}
.auth-foot-stack {
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.auth-foot-alt {
  font-size: 12px;
}
.auth-link {
  color: var(--accent-160);
  font-weight: 700;
  text-decoration: underline;
  text-underline-offset: 2px;
}
.auth-link:hover {
  color: var(--vp-black);
}
</style>
